import inventoryItemsApiService from '@/services/api/InventoryItems'

const emptyModel = {
  id: null,
  label: null,
  description: null,
  code: null,
  unit: null,
  unit_price: null,
  currency: 'EUR',
  stock: 0,
  navigare_margin: 0,
  country_id: null,
  base_id: null,
  contractor_id: null,
  created_by_id: null
}

const emptyFilters = {
  label: null,
  code: null,
  contractor_id: null
}

export default class InventoryItem {
  static api = inventoryItemsApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
